import { put, takeLatest, select, all } from 'redux-saga/effects'

import * as rawActions from '../actions'

function* startLoading(action) {
  const { showPdfSearchResults } = yield select((state) => state.gallery.pdfSearch)
  if (showPdfSearchResults) {
    yield put(rawActions.hidePdfSearchResults())
  }
  yield put(rawActions.startLoading())
}

function* stopLoading(action) {
  const { showPdfSearchResults } = yield select((state) => state.gallery.pdfSearch)
  if (showPdfSearchResults) {
    yield put(rawActions.hidePdfSearchResults())
  }
  yield put(rawActions.stopLoading())
}

function* loadingIndicator() {
  yield all([
    takeLatest(
      [
        rawActions.addGalleryUploadFiles,
        rawActions.addGalleryPdfDocumentsUploadFiles,
        rawActions.addGalleryVideosUploadFiles,
        rawActions.uploadGalleryVideoByUrlRequest,
        rawActions.getGalleryItemRequest,
        rawActions.startGalleryLoading,
      ],
      startLoading
    ),
    takeLatest(
      [
        rawActions.addGalleryUploadFilesFailed,
        rawActions.addGalleryPdfDocumentFailed,
        rawActions.addGalleryVideosUploadFilesFailed,
        rawActions.uploadGalleryVideoByUrlFailed,
        rawActions.addGalleryItem,
        rawActions.onSelectGalleryItem,
        rawActions.onSelectReadonlyGalleryItem,
      ],
      stopLoading
    ),
  ])
}

export default loadingIndicator
